/**
 * Shadow constants for consistent elevation across the app
 *
 * Usage:
 * - Use `shadows.raised` for clickable/interactive elements (buttons, pressable cards)
 * - Use `shadows.subtle` for non-interactive elements that need depth (chat bubbles, info cards)
 */

import { colors } from "./colors";

export const shadows = {
  /**
   * Subtle shadow for non-interactive elements
   * Used for chat bubbles, info cards, and other content that needs subtle depth
   */
  subtle: {
    shadowColor: colors.shadow,
    shadowOffset: {
      width: 0,
      height: 1
    },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 2
  },

  /**
   * Raised shadow for interactive elements
   * Used for buttons, pressable cards, and other clickable components
   */
  raised: {
    shadowColor: colors.shadow,
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 3
  }
} as const;
